import { Card, Flex, Text, Icon, iconWeight } from '@nula/core-ui';
import { useCreateEntity } from '@/lib/workspace/hooks/use-create-entity';
import styles from './quick-actions.module.css';

interface Action {
  key: string;
  icon: string;
  color: string;
  label: string;
  sub: string;
  onClick: () => void;
}

/**
 * Quick-action tiles on the home page — fast entry to the core surfaces.
 * Each tile is a core-ui hoverable Card.
 */
export function QuickActions() {
  const { createNewDocument, createNewCanvas, createNewRecording } = useCreateEntity();

  const actions: Action[] = [
    { key: 'note', icon: 'description', color: 'var(--primary)', label: 'New note', sub: 'Blank document', onClick: () => { void createNewDocument(); } },
    { key: 'canvas', icon: 'gesture', color: 'var(--success)', label: 'New canvas', sub: 'Visual board', onClick: () => { void createNewCanvas(); } },
    { key: 'recording', icon: 'graphic_eq', color: 'var(--error)', label: 'New recording', sub: 'Capture a meeting', onClick: () => { void createNewRecording(); } },
  ];

  return (
    <div className={styles.grid}>
      {actions.map((a) => (
        <Card
          key={a.key}
          hoverable
          onClick={a.onClick}
          className={styles.action}
        >
          <Flex align="center" gap="md">
            <span className={styles.iconTile} style={{ '--qa-color': a.color } as React.CSSProperties}>
              <Icon name={a.icon} size={20} weight={iconWeight.light} />
            </span>
            <Flex vertical>
              <Text className={styles.label}>{a.label}</Text>
              <Text className={styles.sub}>{a.sub}</Text>
            </Flex>
          </Flex>
        </Card>
      ))}
    </div>
  );
}
